module.exports = __webpack_public_path__ + "static/media/arbeitsmittel_active.e8f46219.jpg";